module.exports = __webpack_public_path__ + "media/images/reservation_check_mark-c763c76d65b6efd396c5b6fa66134b29.png";